<template>
  <div class="risk-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('order_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-alert</v-icon>{{$t('order.risk')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <RisksFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page.sync="options.itemsPerPage"
              :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @update:options="onUpdateOptions"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
          >

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import RisksFilterForm from '../../components/risk/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'RiskList',
  servicePrefix: 'Risk',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    RisksFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.value'), value: 'value' },
        { text: this.$t('order.coment'), value: 'comment'},
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('risk', {
      items: 'list'
    }),
    ...mapFields('risk', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('risk', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
